import type { TableState } from '@tanstack/react-table'

export const DEFAULT_ROW_HEIGHT = 40

export const DEFAULT_COLUMN_SIZE = 200

export const DEFAULT_COLUMN_MIN_SIZE = 20

export const DEFAULT_COLUMN_MAX_SIZE = 600

export const FALLBACK_TABLE_STATE: TableState = {
  cellSelection: {},
  columnOrder: [],
  columnPinning: { left: [], right: [] },
  columnVisibility: {},
  rowPinning: {},
  columnFilters: [],
  globalFilter: '',
  sorting: [],
  grouping: [],
  expanded: {},
  pagination: { pageIndex: 0, pageSize: 10 },
  rowSelection: {},
  columnSizing: {},
  columnSizingInfo: {
    columnSizingStart: [],
    deltaOffset: 0,
    deltaPercentage: 0,
    isResizingColumn: false,
    startOffset: null,
    startSize: null,
  },
}
